var overlay = (function($) {
	'use strict';

	var $overlay = $('.overlay');
	var $wrapper = $('.overlay__wrapper');
	var $body = $('body');
	var openState = $overlay.hasClass('overlay--open');

	var open = function() {
		$body.addClass('overlay-open');
		if (!openState) {
			$overlay.fadeIn(200, function() {
				$overlay.addClass('overlay--open');
			});
		}
		openState = true;
	};

	var isOpen = function() {
		return openState;
	};

	var close = function() {
		$body.removeClass('overlay-open');
		if (openState) {
			$overlay.fadeOut(200, function() {
				$overlay.removeClass('overlay--open');
			});
		}
		openState = false;
	};

	var showLoader = function() {
		$overlay.addClass('overlay--loading');
	};

	var hideLoader = function() {
		$overlay.removeClass('overlay--loading');
	};

	var loadUrl = function(url) {
		if (!openState) {
			$wrapper.empty();
		}
		open();
		showLoader();
		$.ajax({
			url: url,
			success: function(response) {
				$wrapper.html(response);
				initLinks($wrapper);
				window.checkFormValidity();
			},
			error: function() {
				close();
			},
			complete: function() {
				hideLoader();
			}
		});
	};

	$('.burger').click(function(e) {
		if (isOpen()) {
			e.preventDefault();
			close();
			return false;
		}
	});

	var initLinks = function($context) {
		$context = typeof $context !== 'undefined' ? $context : $(document);
		$context.find('a.ajax-overlay, .ajax-overlay a, [data-overlay-href]').click(function(e) {
			e.preventDefault();
			var $this = $(this);
			loadUrl($this.attr('href') ? $this.attr('href') : $this.data('overlay-href'));
			return false;
		});
	};
	initLinks();

	return {
		open: open,
		close: close,
		loadUrl: loadUrl
	}

})(jQuery);
